import { Navigate, useLocation, useParams } from 'react-router-dom';

/**
 * Alte Serienmail-Routen (README §10, Entscheidung 14.10.2026): /admin/serienmail → Ordner „Serienmail“ im E-Mail-Bereich,
 * /neu → Assistent, /:id → Lauf. Der Router-State (z. B. startFehler aus „Prüfen und senden“) bleibt erhalten.
 */
export function SerienmailWeiterleitung() {
  const { id } = useParams<{ id: string }>();
  const { pathname, state } = useLocation();
  const lauf = pathname.endsWith('/neu') ? 'neu' : id ?? null;
  const ziel = `/admin/emails?ordner=serienmail${lauf ? `&lauf=${encodeURIComponent(lauf)}` : ''}`;
  return <Navigate to={ziel} replace state={state} />;
}
